import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class QtyComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentQty | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = {
			qty:  null,
			unit: null,
			...settings?.defaultValue,
		};
		this.decimalLimit = settings?.decimalLimit ?? 0;
		this.delimiter = settings?.delimiter ?? false;
		this.disabled = settings?.disabled ?? false;
		this.disableUnit = settings?.disableUnit ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.hideUnit = settings?.hideUnit ?? false;
		this.input = true;
		this.inputType = settings?.inputType ?? 'number';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.protected = settings?.protected ?? false;
		this.requireDecimal = settings?.requireDecimal ?? false;
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			integer:       settings?.validate?.integer ?? '',
			max:           settings?.validate?.max ?? '',
			min:           settings?.validate?.min ?? '',
			step:          settings?.validate?.step ?? 'any',
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'qty',
			'unit',
		]);
	}
}
